import { Component, Input } from '@angular/core';
import { ArgyleViewBag, IdentityViewBag, ArgyleIncomeStream } from '../models/argyle';

@Component({
  selector: 'app-income-ver-card',
  templateUrl: './income-ver-card.component.html',
  styleUrls: ['./income-ver-card.component.less']
})
export class IncomeVerCardComponent {
  @Input() incomeData : ArgyleIncomeStream;
  
  public get identityData() : IdentityViewBag {
    return this.incomeData?.historicalData[0].identityData;
  }
  
}
